import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, VideoIcon, ShoppingBagIcon, DollarSignIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function WhatYouLearn() {
  return <section style={{
    background: 'var(--bg-deep)',
    padding: '64px 16px',
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-171">
      {/* Ambient glow */}
      <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '600px',
      height: '400px',
      background: 'radial-gradient(ellipse, rgba(105,0,175,0.08) 0%, transparent 70%)',
      pointerEvents: 'none'
    }} data-id="element-172" />

      <div style={{
      maxWidth: '1100px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 1
    }} data-id="element-173">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        textAlign: 'center',
        marginBottom: '40px'
      }} data-id="element-174">
          <h2 style={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 900,
          fontSize: 'clamp(28px, 4vw, 44px)',
          color: 'white',
          marginBottom: '14px',
          letterSpacing: '-0.02em'
        }} data-id="element-175">
            Las Habilidades que Aprenderás en Este Masterclass
          </h2>
          <p style={{
          color: '#a0a0b0',
          fontSize: '17px',
          fontFamily: 'Inter, sans-serif',
          maxWidth: '560px',
          margin: '0 auto',
          lineHeight: 1.6
        }} data-id="element-176">
            En 90 minutos dominarás el sistema de competencias digitales que
            define a los vendedores profesionales en TikTok Shop
          </p>
        </motion.div>

        {/* Bento Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'auto auto',
        gap: '12px'
      }} className="bento-grid" data-id="element-177">
          {/* Card 1 — Large (spans 2 cols) */}
          <motion.div variants={cardVariants} whileHover={{
          scale: 1.01
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} style={{
          gridColumn: '1 / -1',
          background: 'linear-gradient(135deg, rgba(24,163,159,0.12) 0%, rgba(242,42,114,0.06) 100%)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(24,163,159,0.2)',
          borderRadius: '20px',
          padding: '24px',
          display: 'flex',
          gap: '16px',
          alignItems: 'flex-start'
        }} data-id="element-178">
            <div style={{
            width: '64px',
            height: '64px',
            borderRadius: '16px',
            background: 'rgba(24,163,159,0.12)',
            border: '1px solid rgba(24,163,159,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }} data-id="element-179">
              <TrendingUpIcon size={32} color="var(--color-teal)" data-id="element-180" />
            </div>
            <div data-id="element-181">
              <h3 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '22px',
              color: 'var(--color-yellow)',
              marginBottom: '10px'
            }} data-id="element-182">
                El Sistema de Comercio Digital Profesional
              </h3>
              <p style={{
              color: '#a0a0b0',
              fontSize: '15px',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.7,
              maxWidth: '600px'
            }} data-id="element-183">
                El método estructurado paso a paso que José aplica para
                construir y operar un negocio de eCommerce sostenible en TikTok
                Shop. Desde la configuración inicial hasta los sistemas de
                automatización y escalabilidad avanzada.
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={cardVariants} whileHover={{
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} style={{
          background: 'rgba(242,42,114,0.06)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(242,42,114,0.18)',
          borderRadius: '20px',
          padding: '28px'
        }} data-id="element-184">
            <div style={{
            width: '52px',
            height: '52px',
            borderRadius: '14px',
            background: 'rgba(242,42,114,0.1)',
            border: '1px solid rgba(242,42,114,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '16px'
          }} data-id="element-185">
              <VideoIcon size={26} color="var(--color-pink)" data-id="element-186" />
            </div>
            <h3 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 800,
            fontSize: '18px',
            color: 'white',
            marginBottom: '8px'
          }} data-id="element-187">
              Contenido que Genera Demanda
            </h3>
            <p style={{
            color: '#a0a0b0',
            fontSize: '14px',
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.6
          }} data-id="element-188">
              Cómo crear videos con alto potencial de alcance orgánico que
              activan el algoritmo y generan tráfico constante a tu tienda
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={cardVariants} whileHover={{
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} style={{
          background: 'rgba(24,163,159,0.06)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(24,163,159,0.15)',
          borderRadius: '20px',
          padding: '28px'
        }} data-id="element-189">
            <div style={{
            width: '52px',
            height: '52px',
            borderRadius: '14px',
            background: 'rgba(24,163,159,0.1)',
            border: '1px solid rgba(24,163,159,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '16px'
          }} data-id="element-190">
              <ShoppingBagIcon size={26} color="var(--color-teal)" data-id="element-191" />
            </div>
            <h3 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 800,
            fontSize: '18px',
            color: 'white',
            marginBottom: '8px'
          }} data-id="element-192">
              Selección de Productos Estratégica
            </h3>
            <p style={{
            color: '#a0a0b0',
            fontSize: '14px',
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.6
          }} data-id="element-193">
              El proceso de investigación y validación para identificar
              productos con alta demanda de mercado y márgenes operativos
              saludables
            </p>
          </motion.div>

          {/* Card 4 — full width */}
          <motion.div variants={cardVariants} whileHover={{
          scale: 1.01
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} style={{
          gridColumn: '1 / -1',
          background: 'rgba(255,226,34,0.04)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,226,34,0.18)',
          borderRadius: '20px',
          padding: '24px',
          display: 'flex',
          gap: '16px',
          alignItems: 'flex-start'
        }} data-id="element-194">
            <div style={{
            width: '52px',
            height: '52px',
            borderRadius: '14px',
            background: 'rgba(255,226,34,0.1)',
            border: '1px solid rgba(255,226,34,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }} data-id="element-195">
              <DollarSignIcon size={26} color="var(--color-yellow)" data-id="element-196" />
            </div>
            <div data-id="element-197">
              <h3 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '20px',
              color: 'var(--color-yellow)',
              marginBottom: '8px'
            }} data-id="element-198">
                Diseño de Sistemas & Escalabilidad Avanzada
              </h3>
              <p style={{
              color: '#a0a0b0',
              fontSize: '14px',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.6,
              maxWidth: '600px'
            }} data-id="element-199">
                Las estrategias de publicidad pagada y automatización operativa
                para escalar tu negocio de forma eficiente. Aprende a construir
                activos digitales sostenibles que trabajen de forma
                independiente.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>

      <style data-id="element-200">{`
        @media (max-width: 640px) {
          .bento-grid {
            grid-template-columns: 1fr !important;
          }
          .bento-grid > *[style*="1 / -1"] {
            grid-column: 1 !important;
          }
        }
      `}</style>
    </section>;
}